(function () {
  'use strict';

  var STORAGE_KEY = 'florixLeadJourney';

  function campaignData() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
    var values = [];
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) values.push(key + ': ' + value);
    });
    return values.join(' | ');
  }

  function rememberJourney() {
    try {
      if (!window.sessionStorage.getItem(STORAGE_KEY)) {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          landingPage: window.location.href,
          originalReferrer: document.referrer || 'Direct / unavailable',
          campaign: campaignData() || 'None recorded'
        }));
      }
    } catch (error) {
      return null;
    }
  }

  function journeyData() {
    try {
      var stored = window.sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  function createGroup(labelText, control) {
    var group = document.createElement('div');
    group.className = 'contact-form__group';

    var label = document.createElement('label');
    label.className = 'contact-form__label';
    label.htmlFor = control.id;
    label.textContent = labelText;

    group.appendChild(label);
    group.appendChild(control);
    return group;
  }

  function createSelect(id, name, placeholder, options, required) {
    var select = document.createElement('select');
    select.id = id;
    select.name = name;
    select.className = 'contact-form__input';
    select.required = Boolean(required);
    if (required) select.setAttribute('aria-required', 'true');

    var prompt = document.createElement('option');
    prompt.value = '';
    prompt.textContent = placeholder;
    prompt.disabled = true;
    prompt.selected = true;
    select.appendChild(prompt);

    options.forEach(function (optionData) {
      var option = document.createElement('option');
      option.value = optionData[0];
      option.textContent = optionData[1];
      select.appendChild(option);
    });
    return select;
  }

  function hiddenField(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value || '';
    form.appendChild(input);
  }

  function enhanceContactForm() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/contact') return;

    var form = document.getElementById('ContactPageForm');
    if (!form || form.dataset.florixEnhanced === 'true') return;

    var message = form.querySelector('#ContactMessage');
    var messageGroup = message ? message.closest('.contact-form__group') : null;
    if (!messageGroup) return;

    var category = createSelect(
      'ContactProductCategory',
      'contact[Product Category]',
      'Select a product category',
      [
        ['Sportswear & Teamwear', 'Sportswear & Teamwear'],
        ['Gym Wear & Activewear', 'Gym Wear & Activewear'],
        ['Tracksuits & Joggers', 'Tracksuits & Joggers'],
        ['Hoodies & Sweatshirts', 'Hoodies & Sweatshirts'],
        ['T-Shirts', 'T-Shirts'],
        ['Leather Jackets', 'Leather Jackets'],
        ['Varsity & Bomber Jackets', 'Varsity & Bomber Jackets'],
        ['Uniforms & Workwear', 'Uniforms & Workwear'],
        ['Denim', 'Denim'],
        ['Martial Arts & Combat Sportswear', 'Martial Arts & Combat Sportswear'],
        ['Motorsport Apparel', 'Motorsport Apparel'],
        ['Caps, Bags & Accessories', 'Caps, Bags & Accessories'],
        ['Private Label Clothing', 'Private Label Clothing'],
        ['Other', 'Other']
      ],
      true
    );

    var quantity = createSelect(
      'ContactQuantity',
      'contact[Estimated Quantity]',
      'Select estimated quantity',
      [
        ['Sample only', 'Sample only'],
        ['5–25 pieces', '5–25 pieces'],
        ['26–100 pieces', '26–100 pieces'],
        ['101–500 pieces', '101–500 pieces'],
        ['501–1,000 pieces', '501–1,000 pieces'],
        ['1,000+ pieces', '1,000+ pieces']
      ],
      true
    );

    var country = document.createElement('input');
    country.id = 'ContactDeliveryCountry';
    country.type = 'text';
    country.name = 'contact[Delivery Country]';
    country.className = 'contact-form__input';
    country.placeholder = 'United Kingdom';
    country.autocomplete = 'country-name';
    country.required = true;
    country.setAttribute('aria-required', 'true');

    var deadline = document.createElement('input');
    deadline.id = 'ContactTargetDate';
    deadline.type = 'date';
    deadline.name = 'contact[Target Date]';
    deadline.className = 'contact-form__input';
    deadline.min = new Date().toISOString().split('T')[0];

    var rowOne = document.createElement('div');
    rowOne.className = 'contact-form__row';
    rowOne.appendChild(createGroup('Product Category *', category));
    rowOne.appendChild(createGroup('Estimated Quantity *', quantity));

    var rowTwo = document.createElement('div');
    rowTwo.className = 'contact-form__row';
    rowTwo.appendChild(createGroup('Delivery Country *', country));
    rowTwo.appendChild(createGroup('Target Date / Deadline', deadline));

    form.insertBefore(rowOne, messageGroup);
    form.insertBefore(rowTwo, messageGroup);

    if (message) {
      message.placeholder = 'Tell us about the product, fabric or GSM, sizes, colours, branding, packaging and any reference designs...';
    }

    var submit = form.querySelector('.contact-form__submit');
    if (submit) {
      Array.from(submit.childNodes).some(function (node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
          node.nodeValue = '\n            Request Manufacturing Quote\n          ';
          return true;
        }
        return false;
      });
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var journey = journeyData() || {};
    hiddenField(form, 'contact[Lead Type]', 'Manufacturing Quote');
    hiddenField(form, 'contact[Source Page]', window.location.pathname);
    hiddenField(form, 'contact[Source URL]', canonical ? canonical.href : window.location.href.split('#')[0]);
    hiddenField(form, 'contact[Previous Page]', document.referrer || 'Direct / unavailable');
    hiddenField(form, 'contact[Original Landing Page]', journey.landingPage || window.location.href);
    hiddenField(form, 'contact[Original Referrer]', journey.originalReferrer || document.referrer || 'Direct / unavailable');
    hiddenField(form, 'contact[Campaign Data]', campaignData() || journey.campaign || 'None recorded');

    form.dataset.florixEnhanced = 'true';
  }

  rememberJourney();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContactForm);
  } else {
    enhanceContactForm();
  }
})();
